// Asset list main page
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setProject } from '../../../redux/actions/projects';
import ControlTable from './ControlTable';
// View for Control List
const Controls = ({ controls, loading, project, setProject, profile }) => {
  useEffect(() => {
    if (profile !== null) {
      if ((project === undefined || project === null) && loading === false) {
        var url = window.location.pathname;
        var splitUrl = url.split('/');
        var projectId = splitUrl[1];
        if (projectId !== undefined) {
          const projectTemplate = { _id: projectId };
          setProject(projectTemplate);
        }
      }
    }
  }, [project, loading, profile]);

  return (
    <div style={{ backfaceVisibility: 'visible', background: 'white' }}>
      <ControlTable controls={controls} />{' '}
    </div>
  );
};

const mapStateToProps = (state) => ({
  //   auth: state.auth,
  controls: state.controls.controls,
  loading: state.project.loading,
  project: state.project.project,
  profile: state.profile.profile,
});
export default connect(mapStateToProps, { setProject })(Controls);
